import {Column, HeaderProps} from 'react-table'
import {PropsWithChildren} from 'react'
import {Role} from './_model'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import {KTIcon} from '../../../../_metronic/helpers'

const roleListColumn = (
  handleSelect: (selectType: string, id: number) => void
): ReadonlyArray<Column<Role>> => {
  const onEdit = (id: number) => handleSelect('edit', id)
  const onView = (id: number) => handleSelect('view', id)
  const onEditRole = (id: number) => handleSelect('roleEdit', id)

  return [
    {
      Header: (props: PropsWithChildren<HeaderProps<Role>>) => (
        <CustomHeader tableProps={props} title='role name' className='min-w-100px' />
      ),
      id: 'level_name',
      accessor: 'level_name',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<Role>>) => (
        <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
      ),
      id: 'action',
      Cell: ({...props}) => (
        <div className='text-end'>
          <a
            href='#'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_2'
            onClick={() => onView(props.data[props.row.index].id_level)}
            title='View Assigned Role'
          >
            <KTIcon iconName='eye' className='fs-3 text-info' />
          </a>
          <a
            href='#'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={() => onEdit(props.data[props.row.index].id_level)}
            title='Edit Assigned Role'
          >
            <KTIcon iconName='user-edit' className='fs-3 text-success' />
          </a>
          <a
            href='#'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
            onClick={() => onEditRole(props.data[props.row.index].id_level)}
            title='Edit Role name'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_4'
          >
            <KTIcon iconName='pencil' className='fs-3 text-info' />
          </a>
        </div>
      ),
    },
  ]
}

export default roleListColumn
